/* unplugin-vue-components disabled */import { render } from "./CommonTitle.vue?vue&type=template&id=57fd153c&scoped=true"
import script from "./CommonTitle.vue?vue&type=script&lang=js"
export * from "./CommonTitle.vue?vue&type=script&lang=js"

import "./CommonTitle.vue?vue&type=style&index=0&id=57fd153c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fd153c"]])

export default __exports__